import {Noun, Nationality, Pronoun} from '../model/Helper';

const PaperParty = (party, type)=>{
    let blankLine = "____________________";
    let nounParty = Noun(party, type);

    let legalPersonality=[], name=[], spouseName=[], nationality=[], maritalStatus=[], address=[], hasRepresentative=[], representativeName=[], representativeNationality=[], representativeAddress=[];
    let corporationName=[], corporationAddress=[], corporationRepresentativeName=[], corporationRepresentativePosition=[], gender=[];

    if(type==="seller"){
        party.forEach((p, i)=>{
            legalPersonality[i] = p.legalPersonality;

            name[i] = (p.sellerFname || p.sellerMname || p.sellerLname) ? 
            (p.sellerFname+(p.sellerMname?` ${p.sellerMname}`:"")+(p.sellerLname?` ${p.sellerLname}`:"")+(p.sellerSuffix?` ${p.sellerSuffix}`:"")): 
            blankLine;

            gender[i] = p.sellerGender;

            maritalStatus[i] = p.sellerMaritalStatus;

            spouseName[i] = (p.sellerSpouseFname || p.sellerSpouseMname || p.sellerSpouseLname) ? 
            (p.sellerSpouseFname+(p.sellerSpouseMname?` ${p.sellerSpouseMname}`:"")+(p.sellerSpouseLname?` ${p.sellerSpouseLname}`:"")+(p.sellerSpouseSuffix?` ${p.sellerSpouseSuffix}`:"")): 
            blankLine; 

            nationality[i] = p.sellerNationality || blankLine;

            address[i] = p.sellerAddress || blankLine;

            hasRepresentative[i] = p.sellerHasRepresentative || blankLine;

            representativeName[i] = (p.sellerRepresentativeFname || p.sellerRepresentativeMname || p.sellerRepresentativeLname) ? 
            (p.sellerRepresentativeFname+(p.sellerRepresentativeMname?` ${p.sellerRepresentativeMname}`:"")+(p.sellerRepresentativeLname?` ${p.sellerRepresentativeLname}`:"")+(p.sellerRepresentativeSuffix?` ${p.sellerRepresentativeSuffix}`:"")): 
            blankLine;

            representativeNationality[i] = p.sellerRepresentativeNationality || blankLine;

            representativeAddress[i] = p.sellerRepresentativeAddress || blankLine;

            corporationName[i] = p.sellerCorporationName || blankLine;
            
            corporationAddress[i] = p.sellerCorporationPrincipalPlaceOfBusiness?        p.sellerCorporationPrincipalPlaceOfBusiness:blankLine;

            corporationRepresentativeName[i] = (p.sellerCorporationRepresentativeFname || p.sellerCorporationRepresentativeMname || p.sellerCorporationRepresentativeLname) ? 
            (p.sellerCorporationRepresentativeFname+(p.sellerCorporationRepresentativeMname?` ${p.sellerCorporationRepresentativeMname}`:"")+(p.sellerCorporationRepresentativeLname?` ${p.sellerCorporationRepresentativeLname}`:"")+(p.sellerCorporationRepresentativeSuffix?` ${p.sellerCorporationRepresentativeSuffix}`:"")): 
            blankLine;

            corporationRepresentativePosition[i] = p.sellerCorporationRepresentativePosition?p.sellerCorporationRepresentativePosition:blankLine
        })
    }

    if(type==="buyer"){
        party.forEach((p, i)=>{
            legalPersonality[i] = p.legalPersonality;

            name[i] = (p.buyerFname || p.buyerMname || p.buyerLname) ? 
            (p.buyerFname+(p.buyerMname?` ${p.buyerMname}`:"")+(p.buyerLname?` ${p.buyerLname}`:"")+(p.buyerSuffix?` ${p.buyerSuffix}`:"")): 
            blankLine;

            gender[i] = p.buyerGender;

            maritalStatus[i] = p.buyerMaritalStatus;

            spouseName[i] = (p.buyerSpouseFname || p.buyerSpouseMname || p.buyerSpouseLname) ? 
            (p.buyerSpouseFname+(p.buyerSpouseMname?` ${p.buyerSpouseMname}`:"")+(p.buyerSpouseLname?` ${p.buyerSpouseLname}`:"")+(p.buyerSpouseSuffix?` ${p.buyerSpouseSuffix}`:"")): 
            blankLine; 

            nationality[i] = p.buyerNationality || blankLine;

            address[i] = p.buyerAddress || blankLine;

            hasRepresentative[i] = p.buyerHasRepresentative || blankLine;

            representativeName[i] = (p.buyerRepresentativeFname || p.buyerRepresentativeMname || p.buyerRepresentativeLname) ? 
            (p.buyerRepresentativeFname+(p.buyerRepresentativeMname?` ${p.buyerRepresentativeMname}`:"")+(p.buyerRepresentativeLname?` ${p.buyerRepresentativeLname}`:"")+(p.buyerRepresentativeSuffix?` ${p.buyerRepresentativeSuffix}`:"")): 
            blankLine;

            representativeNationality[i] = p.buyerRepresentativeNationality || blankLine;

            representativeAddress[i] = p.buyerRepresentativeAddress || blankLine;

            corporationName[i] = p.buyerCorporationName || blankLine;
            
            corporationAddress[i] = p.buyerCorporationPrincipalPlaceOfBusiness?        p.buyerCorporationPrincipalPlaceOfBusiness:blankLine;

            corporationRepresentativeName[i] = (p.buyerCorporationRepresentativeFname || p.buyerCorporationRepresentativeMname || p.buyerCorporationRepresentativeLname) ? 
            (p.buyerCorporationRepresentativeFname+(p.buyerCorporationRepresentativeMname?` ${p.buyerCorporationRepresentativeMname}`:"")+(p.buyerCorporationRepresentativeLname?` ${p.buyerCorporationRepresentativeLname}`:"")+(p.buyerCorporationRepresentativeSuffix?` ${p.buyerCorporationRepresentativeSuffix}`:"")): 
            blankLine;

            corporationRepresentativePosition[i] = p.buyerCorporationRepresentativePosition?p.buyerCorporationRepresentativePosition:blankLine
        })
    }

    if(type==="mortgagor"){
        party.forEach((p, i)=>{
            legalPersonality[i] = p.legalPersonality;

            name[i] = (p.mortgagorFname || p.mortgagorMname || p.mortgagorLname) ? 
            (p.mortgagorFname+(p.mortgagorMname?` ${p.mortgagorMname}`:"")+(p.mortgagorLname?` ${p.mortgagorLname}`:"")+(p.mortgagorSuffix?` ${p.mortgagorSuffix}`:"")): 
            blankLine;

            gender[i] = p.mortgagorGender;

            maritalStatus[i] = p.mortgagorMaritalStatus;

            spouseName[i] = (p.mortgagorSpouseFname || p.mortgagorSpouseMname || p.mortgagorSpouseLname) ? 
            (p.mortgagorSpouseFname+(p.mortgagorSpouseMname?` ${p.mortgagorSpouseMname}`:"")+(p.mortgagorSpouseLname?` ${p.mortgagorSpouseLname}`:"")+(p.mortgagorSpouseSuffix?` ${p.mortgagorSpouseSuffix}`:"")): 
            blankLine; 

            nationality[i] = p.mortgagorNationality || blankLine;

            address[i] = p.mortgagorAddress || blankLine;

            hasRepresentative[i] = p.mortgagorHasRepresentative || blankLine;

            representativeName[i] = (p.mortgagorRepresentativeFname || p.mortgagorRepresentativeMname || p.mortgagorRepresentativeLname) ? 
            (p.mortgagorRepresentativeFname+(p.mortgagorRepresentativeMname?` ${p.mortgagorRepresentativeMname}`:"")+(p.mortgagorRepresentativeLname?` ${p.mortgagorRepresentativeLname}`:"")+(p.mortgagorRepresentativeSuffix?` ${p.mortgagorRepresentativeSuffix}`:"")): 
            blankLine;

            representativeNationality[i] = p.mortgagorRepresentativeNationality || blankLine;

            representativeAddress[i] = p.mortgagorRepresentativeAddress || blankLine;

            corporationName[i] = p.mortgagorCorporationName || blankLine;
            
            corporationAddress[i] = p.mortgagorCorporationPrincipalPlaceOfBusiness?        p.mortgagorCorporationPrincipalPlaceOfBusiness:blankLine;

            corporationRepresentativeName[i] = (p.mortgagorCorporationRepresentativeFname || p.mortgagorCorporationRepresentativeMname || p.mortgagorCorporationRepresentativeLname) ? 
            (p.mortgagorCorporationRepresentativeFname+(p.mortgagorCorporationRepresentativeMname?` ${p.mortgagorCorporationRepresentativeMname}`:"")+(p.mortgagorCorporationRepresentativeLname?` ${p.mortgagorCorporationRepresentativeLname}`:"")+(p.mortgagorCorporationRepresentativeSuffix?` ${p.mortgagorCorporationRepresentativeSuffix}`:"")): 
            blankLine;

            corporationRepresentativePosition[i] = p.mortgagorCorporationRepresentativePosition?p.mortgagorCorporationRepresentativePosition:blankLine
        })
    }

    if(type==="mortgagee"){
        party.forEach((p, i)=>{
            legalPersonality[i] = p.legalPersonality;

            name[i] = (p.mortgageeFname || p.mortgageeMname || p.mortgageeLname) ? 
            (p.mortgageeFname+(p.mortgageeMname?` ${p.mortgageeMname}`:"")+(p.mortgageeLname?` ${p.mortgageeLname}`:"")+(p.mortgageeSuffix?` ${p.mortgageeSuffix}`:"")): 
            blankLine;

            gender[i] = p.mortgageeGender;

            maritalStatus[i] = p.mortgageeMaritalStatus;

            spouseName[i] = (p.mortgageeSpouseFname || p.mortgageeSpouseMname || p.mortgageeSpouseLname) ? 
            (p.mortgageeSpouseFname+(p.mortgageeSpouseMname?` ${p.mortgageeSpouseMname}`:"")+(p.mortgageeSpouseLname?` ${p.mortgageeSpouseLname}`:"")+(p.mortgageeSpouseSuffix?` ${p.mortgageeSpouseSuffix}`:"")): 
            blankLine; 

            nationality[i] = p.mortgageeNationality || blankLine;

            address[i] = p.mortgageeAddress || blankLine;

            hasRepresentative[i] = p.mortgageeHasRepresentative || blankLine;

            representativeName[i] = (p.mortgageeRepresentativeFname || p.mortgageeRepresentativeMname || p.mortgageeRepresentativeLname) ? 
            (p.mortgageeRepresentativeFname+(p.mortgageeRepresentativeMname?` ${p.mortgageeRepresentativeMname}`:"")+(p.mortgageeRepresentativeLname?` ${p.mortgageeRepresentativeLname}`:"")+(p.mortgageeRepresentativeSuffix?` ${p.mortgageeRepresentativeSuffix}`:"")): 
            blankLine;

            representativeNationality[i] = p.mortgageeRepresentativeNationality || blankLine;

            representativeAddress[i] = p.mortgageeRepresentativeAddress || blankLine;

            corporationName[i] = p.mortgageeCorporationName || blankLine;
            
            corporationAddress[i] = p.mortgageeCorporationPrincipalPlaceOfBusiness?        p.mortgageeCorporationPrincipalPlaceOfBusiness:blankLine;

            corporationRepresentativeName[i] = (p.mortgageeCorporationRepresentativeFname || p.mortgageeCorporationRepresentativeMname || p.mortgageeCorporationRepresentativeLname) ? 
            (p.mortgageeCorporationRepresentativeFname+(p.mortgageeCorporationRepresentativeMname?` ${p.mortgageeCorporationRepresentativeMname}`:"")+(p.mortgageeCorporationRepresentativeLname?` ${p.mortgageeCorporationRepresentativeLname}`:"")+(p.mortgageeCorporationRepresentativeSuffix?` ${p.mortgageeCorporationRepresentativeSuffix}`:"")): 
            blankLine;

            corporationRepresentativePosition[i] = p.mortgageeCorporationRepresentativePosition?p.mortgageeCorporationRepresentativePosition:blankLine
        })
    }

    let paperPartyPdf=`<div class=${`paper-narrow text-justify`}>`;

    party.forEach((p, i)=>{
        // Individual
        if(legalPersonality[i]===`Natural Person`){
            paperPartyPdf+=`<span class="no-indent" key=${i}>${i>0 && i!==i.length-1?`<span>; </span>`:``}${maritalStatus[i]===`Married`?`<span class="font-weight-bold">SPOUSES &nbsp;</span>`:``}<span class="text-uppercase font-weight-bold">${name[i]}</span>${maritalStatus[i]===`Married`?`<span class="font-weight-bold text-uppercase"> <span class="text-lowercase">and</span> ${spouseName[i]}</span>`:``}, <span class="text-capitalize">${Nationality(nationality[i], maritalStatus[i])}</span>, ${maritalStatus[i]===`Married`?`both `:``}of legal age, with address at <span class="text-capitalize">${address[i]}</span><span class=${hasRepresentative[i]===`Yes`?``:`d-none`}>,  represented herein by ${Pronoun("his", gender[i], legalPersonality[i], nounParty)} attorney-in-fact, <span class="text-uppercase font-weight-bold">${representativeName[i]}</span>, <span class="text-capitalize">${representativeNationality[i]}</span>, of legal age, with address at <span class="text-capitalize">${representativeAddress[i]}</span>${type==="seller"?`, whose Special Power of Attorney is attached hereto`:``}</span></span>`;         
        // Corporation
        } else {
            paperPartyPdf+=`<span key=${i}>${i>0 && i!==i.length-1?`<span>; </span>`:``}<span class="text-uppercase font-weight-bold">${corporationName[i]}</span>, a corporation duly organized and existing under and by virtue of the laws of the Republic of the Philippines, with principal business address at <span class="text-capitalize">${corporationAddress[i]}</span>, and represented herein by its <span class="text-capitalize">${corporationRepresentativePosition[i]}</span>, <span class="text-uppercase font-weight-bold">${corporationRepresentativeName[i]}</span>, via authorization by the Board of Directors as evinced by the Secretary's Certificate attached hereto</span>`;
        }
    })  

    paperPartyPdf+=`, hereinafter referred to as the <span class="font-weight-bold text-uppercase"}>"${nounParty}"</span>${type==="seller" || type==="mortgagor"?";":"."}`
    paperPartyPdf+=`</div>`;

    return paperPartyPdf;
}

export default PaperParty;


// WEBPACK FOOTER //
// ./src/model/PaperPartyPdf.js